export const FAQS = [
  {
    q: { en: "What is LUMORA?", zh: "LUMORA 是什么？" },
    a: {
      en: "LUMORA is a free, colorful educational world where children and families learn, play games, read stories, and discover how a community can support accessible education. Learning is the main product.",
      zh: "LUMORA 是一个免费、多彩的教育世界，孩子和家庭可以在这里学习、玩游戏、读故事，并了解社区如何支持可及的教育。学习是它的核心产品。",
    },
  },
  {
    q: { en: "Is learning free?", zh: "学习是免费的吗？" },
    a: {
      en: "Yes. All lessons, games, and stories are completely free to use. No account and no crypto wallet are required to learn.",
      zh: "是的。所有课程、游戏和故事都完全免费使用。学习无需账号，也无需加密钱包。",
    },
  },
  {
    q: { en: "How does LUMORA support education?", zh: "LUMORA 如何支持教育？" },
    a: {
      en: "LUMORA plans to support free education through transparent charitable contributions. When the donation infrastructure is live, every contribution will be traceable on-chain with a public explorer link.",
      zh: "LUMORA 计划通过透明的慈善捐助支持免费教育。待捐助基础设施上线后，每一笔捐助都将可在链上追溯，并附带公开的区块链浏览器链接。",
    },
  },
  {
    q: { en: "What is the intended relationship with Giggle Academy?", zh: "与 Giggle Academy 的预期关系是什么？" },
    a: {
      en: "LUMORA is an independent initiative inspired by the goal of making education more accessible. We aim to support Giggle Academy's educational mission through transparent charitable contributions, subject to recipient verification and the applicable donation process.",
      zh: "LUMORA 是一项独立倡议，受到让教育更可及这一目标的启发。我们希望通过透明的慈善捐助支持 Giggle Academy 的教育使命，但须经接收方核实并遵循相应的捐助流程。",
    },
  },
  {
    q: { en: "Is LUMORA officially affiliated with Giggle Academy?", zh: "LUMORA 是否与 Giggle Academy 有官方关联？" },
    a: {
      en: "No. LUMORA is not officially partnered with, endorsed by, owned by, or operated by Giggle Academy. A donation or contribution does not establish an official partnership.",
      zh: "没有。LUMORA 与 Giggle Academy 之间不存在官方合作、背书、所有或运营关系。捐助或贡献并不构成正式合作关系。",
    },
  },
  {
    q: { en: "How are charitable contributions verified?", zh: "慈善捐助如何核实？" },
    a: {
      en: "Contributions move through clear stages: Planned, Awaiting verification, Pending, Confirmed, and Failed. Only confirmed on-chain transactions with a transaction hash count as completed donations.",
      zh: "捐助会经过清晰的阶段：计划中、待核实、待处理、已确认和失败。只有带有交易哈希、已在链上确认的交易，才算作已完成的捐助。",
    },
  },
  {
    q: { en: "Where can I find the token contract?", zh: "在哪里可以找到代币合约？" },
    a: {
      en: "The contract address is Coming Soon. We will never display a fabricated contract address. Check the Token page for the latest verified status.",
      zh: "合约地址敬请期待。我们绝不会显示虚构的合约地址。请在代币页面查看最新的已验证状态。",
    },
  },
  {
    q: { en: "Which blockchain is planned?", zh: "计划使用哪条区块链？" },
    a: {
      en: "BNB Smart Chain is planned, subject to final deployment confirmation.",
      zh: "计划使用 BNB Smart Chain，具体以最终部署确认为准。",
    },
  },
  {
    q: { en: "How do I access the educational games?", zh: "如何使用教育游戏？" },
    a: {
      en: "Just open the Play page and pick a game. Everything runs in your browser — no download, no login, no payment.",
      zh: "只需打开 “趣味游戏” 页面并选择一个游戏。全部在浏览器中运行——无需下载、无需登录、无需付费。",
    },
  },
  {
    q: { en: "What personal data does the website collect?", zh: "网站会收集哪些个人数据？" },
    a: {
      en: "The core learning experience does not require an account. Your lesson and game progress is saved only in your own browser. We do not collect unnecessary personal information from children.",
      zh: "核心学习体验无需账号。你的课程和游戏进度只保存在你自己的浏览器中。我们不会收集儿童不必要的个人信息。",
    },
  },
  {
    q: { en: "Is a crypto wallet required to learn?", zh: "学习需要加密钱包吗？" },
    a: {
      en: "No. A crypto wallet is never required to learn, play, or read stories on LUMORA. Token participation is entirely separate from education.",
      zh: "不需要。在 LUMORA 学习、游玩或阅读故事从不需要加密钱包。参与代币与教育完全分开。",
    },
  },
];
